import FindDoctors from "./components/FindDoctorsPage";

const App = () => (
  <div>
    <FindDoctors />
  </div>
);

export default App;
